import hexapodImage from '../../../Assets/images/Create Actions/Hexapod.png'
import humanoidImage from '../../../Assets/images/ZingImage.png'
import { withBrandDeviceImage } from '../../../hooks/useBrandConfig'

const ACTION_DEVICE_IMAGES = {
    get HEXAPOD() {
        return withBrandDeviceImage(hexapodImage, 'Hexapod')
    },
    get HUMANOID() {
        return withBrandDeviceImage(humanoidImage, 'Humanoid')
    },
}

export default ACTION_DEVICE_IMAGES
